.root {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: space-between;
}

.title {
  overflow: hidden;
  font-size: 2rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.badge {
  text-wrap: nowrap;
}
